import evWebsiteImg from "../img/designs/ev-website.png";
import miraclesImg from "../img/designs/miracles.png";
import pestImg from "../img/designs/pest-web.png";
import crystalImg from "../img/designs/crystal-page.png";
import ballonImg from "../img/designs/ballon-page.png";

const webDesignData = [
  {
    id: 0,
    link: "https://sample.mikewebdev.com/",
    src: ballonImg,
    info: "Ballons Website",
    about:
      "Balloonsbycaro website, showcasing Caro’s passion and artistry in transforming events into elegant, breathtaking experiences",
    tags: ["web design", "web development"],
  },
  {
    id: 1,
    link: "https://sample-pest.netlify.app/",
    src: pestImg,
    info: "Pest Website",
    tags: ["web design", "web development"],
    about:
      "Take your business to the next level with custom website development services, creating impactful digital experiences.",
  },
  {
    id: 2,
    link: "https://evchargerinstallnj.com/",
    src: evWebsiteImg,
    info: "Ev-Charger",
    tags: ["wordpress development", "web design"],
    about:
      "A company specializing in installing vehicle chargers requested a website, which I developed using WordPress.",
  },
  {
    id: 3,
    link: "https://nexustential.github.io/MiraclesMassage",
    src: miraclesImg,
    info: "Miracles Massage",
    tags: ["web design", "web development"],
    about:
      "This was one of my first projects, after I was done with my Bootcamp, we created this static website really well designed, and mobile-friendly.",
  },
  {
    id: 4,
    link: "https://jazzy-treacle-e0ad5b.netlify.app/",
    src: crystalImg,
    info: "Crystal Page",
    tags: ["e-commerce", "web design"],
    about:
      "I built the Rising Spirit Crystals website, Brooklyn-based crystal collection. Customers can discover healing, manifestation, spiritual growth.",
  },
];

export default webDesignData;
